import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";

import i18nInit from '@noku-tech/nokulibrary-frontend/dist/i18n';

import translationEN from './assets/locales/en/translation.json';
import translationIT from './assets/locales/it/translation.json';
import translationKO from './assets/locales/ko/translation.json';

import 'bootstrap/dist/css/bootstrap.min.css'; //? bootstrap is only included for style?
import 'jcf/dist/css/theme-minimal/jcf.css'; // ?
import 'jcf/dist/js/jcf'; // ?
import 'jcf/dist/js/jcf.select'; // ?
import 'jcf/dist/js/jcf.radio'; // ?
import 'jcf/dist/js/jcf.checkbox'; // ?
import 'jcf/dist/js/jcf.scrollable'; // ?
import 'lato-font/css/lato-font.min.css';

import * as serviceWorker from './serviceWorker';

import './index.scss';

import store from './store/store';
import { Provider } from 'react-redux';

import Loading from "./components/Loading/Loading";

const App = lazy(() => import("./App"));

i18nInit('noku-account', translationEN, translationIT, translationKO).then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter basename="/app">
        <Suspense fallback={<Loading />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </Provider>, document.getElementById('root'));

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: http://bit.ly/CRA-PWA
  serviceWorker.unregister();

  // serviceWorker.register({
  //   onUpdate:(registration) => {
  //     notify({
  //       title: 'New update is available!',
  //       message: 'Please click the "update now" button.',
  //       position: 'tr',
  //       status: 'info',
  //       dismissAfter: 0,
  //       dismissible: false,
  //       buttons: [{
  //         name: 'Update now',
  //         primary: true,
  //         onClick: () => {
  //           registration.waiting && registration.waiting.postMessage("skipWaiting");
  //           setTimeout( () => {
  //             window.location.reload(true);
  //           }, 500);
  //         }
  //       }]
  //     })(store.dispatch, store.getState);

  //   }
  // });

});